export default "__VITE_ASSET__B9V7R4iQ__"